'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SectionHeaderComponent = require('../common/SectionHeaderComponent');

var _SectionHeaderComponent2 = _interopRequireDefault(_SectionHeaderComponent);

var _StripeCreditCardComponent = require('../input/StripeCreditCardComponent');

var _StripeCreditCardComponent2 = _interopRequireDefault(_StripeCreditCardComponent);

var _translate = require('../../language/translate');

var _url = require('../../../util/url');

var _url2 = _interopRequireDefault(_url);

var _TugoCreditCardComponent = require('../input/TugoCreditCardComponent');

var _TugoCreditCardComponent2 = _interopRequireDefault(_TugoCreditCardComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders a Stripe Credit Card input component along with a corresponding label.
 */
var PaymentSectionComponent = function (_React$Component) {
  _inherits(PaymentSectionComponent, _React$Component);

  function PaymentSectionComponent() {
    _classCallCheck(this, PaymentSectionComponent);

    return _possibleConstructorReturn(this, (PaymentSectionComponent.__proto__ || Object.getPrototypeOf(PaymentSectionComponent)).apply(this, arguments));
  }

  _createClass(PaymentSectionComponent, [{
    key: 'render',
    value: function render() {
      return !(0, _url2.default)('user_code', null) && _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _SectionHeaderComponent2.default,
          null,
          (0, _translate.t)('Payment Information')
        ),
        this.props.isTugo ? _react2.default.createElement(_TugoCreditCardComponent2.default, {
          fields: this.props.fields,
          source: this.props.formName
        }) : _react2.default.createElement(_StripeCreditCardComponent2.default, {
          fields: this.props.fields,
          source: this.props.formName
        })
      );
    }
  }]);

  return PaymentSectionComponent;
}(_react2.default.Component);

PaymentSectionComponent.propTypes = {
  fields: _react2.default.PropTypes.object,
  formName: _react2.default.PropTypes.string,
  isTugo: _react2.default.PropTypes.bool
};
exports.default = PaymentSectionComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/PaymentSectionComponent.jsx
// module id = 1667
// module chunks = 0